
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect-mcp",
      function () {
        return require("private-next-pages/connect-mcp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connect-mcp"])
      });
    }
  